import {createStyles, makeStyles} from '@material-ui/core'
import {Colors} from 'components/common/useBaseStyle'

const ProductUsageHistoryStyle = () =>
  createStyles({
    listTabs: {
      display: 'flex',
    },
    activeTabs: {
      color: '#0bc7c8 !important',
    },
    active: {
      height: '3px',
      borderRadius: '2px',
      backgroundColor: '#0bc7c8',
      marginBottom: '-2.5px',
    },
    productsGrid: {
      marginTop: '25px',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(420px, 420px))',
      gap: '25px',
      alignItems: 'start',
    },
    infoProductActive: {
      borderColor: '#0cc7c7 !important',
      background: '#e2ffff !important',
    },
    infoProduct: {
      padding: '15px',
      minWidth: '420px',
      maxWidth: '480px',
      height: '100%',
      background: 'white',
      border: '2px solid #e0e0e0',
      borderRadius: '12px',
      overflow: 'hidden',
      position: 'relative',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
      transition: 'all 0.3s ease',
      animation: 'fadeInUp 0.6s ease-out',
      cursor: 'pointer',
      '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
        borderColor: '#0cc7c7',
      },
      '&::before': {
        content: "''",
        position: 'absolute',
        top: '-2px',
        left: '-2px',
        right: '-2px',
        bottom: '-2px',
        background: 'linear-gradient(45deg, #0cc7c7, #17a2b8, #0cc7c7)',
        borderRadius: '14px',
        zIndex: '-1',
        opacity: 0,
        transition: 'opacity 0.3s ease',
      },
      '&:hover::before': {
        opacity: 0.1,
      },
    },
    productTitle: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#333',
      marginBottom: '8px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },

    productType: {
      color: '#666',
      fontSize: '14px',
      marginBottom: '12px',
    },

    // *start ValueAnalysisNumber*
    productFlex: {
      marginTop: '25px',
      gridTemplateColumns: 'repeat(5, 280px)',
      display: 'grid',
      gap: '20px',
      alignItems: 'start',
    },
    cardAnalysisNumber: {
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(20px)',
      borderRadius: '24px',
      padding: '32px',
      boxShadow: '0 0 6px rgba(0, 0, 0, 0.15)',
      height: '100%',
      minWidth: '200px',
      position: 'relative',
      // overflow: 'hidden',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      '&:hover': {
        transform: 'translateY(-8px)',
        boxShadow: '0 0px 6px rgba(0, 0, 0, 0.15)',
        borderColor: '#0cc7c7',
      },
      '&::before': {
        content: "''",
        position: 'absolute',
        top: '-2px',
        left: '-2px',
        right: '-2px',
        bottom: '-2px',
        background: 'linear-gradient(45deg, #0cc7c7, #17a2b8, #0cc7c7)',
        borderRadius: '14px',
        zIndex: '-1',
        opacity: 0,
        transition: 'opacity 0.3s ease',
      },
      '&:hover::before': {
        opacity: 0.1,
      },
    },
    headerAnalysisNumber: {
      textAlign: 'center',
      marginBottom: '24px',
    },

    titleAnalysisNumber: {
      color: '#2c3e50',
      fontSize: '14px',
      fontWeight: 600,
      letterSpacing: '0.5px',
      marginBottom: '8px',
      opacity: 0.8,
    },

    mainValueAnalysisNumber: {
      fontSize: '42px',
      fontWeight: 800,
      color: '#2c3e50',
      margin: '16px 0',
      position: 'relative',
      textShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    },
    metricsValueAnalysisNumber: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '16px',
      marginTop: '24px',
    },
    metric: {
      textAlign: 'center',
      padding: '16px 8px',
      background: 'rgba(255, 255, 255, 0.7)',
      borderRadius: '16px',
      border: '1px solid #e0e0e0',
      transition: 'all 0.3s ease',
      position: 'relative',
      overflow: 'hidden',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
        borderColor: '#0cc7c7',
      },
    },

    metricLabel: {
      fontSize: '11px',
      color: '#7f8c8d',
      fontWeight: 500,
      marginBottom: '4px',
      letterSpacing: '0.3px',
    },

    metricValue: {
      fontSize: '16px',
      fontWeight: 700,
      color: '#2c3e50',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    table: {
      position: 'relative',
      minWidth: 880,
      color: 'red',
      marginTop: '25px',
      '& th': {borderLeft: '1px solid #dfdfdf'},
      '& td': {
        color: Colors.text.content,
        fontSize: '0.8125rem',
        lineHeight: 2,
        paddingTop: 6,
        paddingBottom: 6,
        height: 43,
        borderLeft: '1px solid #dfdfdf',
      },
      '& td:last-child': {
        borderRight: '1px solid #dfdfdf',
      },
    },
    cellRedirect: {
      cursor: 'pointer',
      maxWidth: 400,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    tableHeader: {
      height: 42,
      backgroundColor: Colors.tableHeaderBackground,
      verticalAlign: 'middle',
      borderRadius: 10,
      '& th': {
        color: Colors.text.content,
        fontSize: '0.8125rem',
        lineHeight: '1rem',
        fontWeight: 'bold',
      },
    },
    rowCell: {
      cursor: 'pointer',
    },
    tabsUnderline: {
      display: 'flex',
      marginTop: '40px',
      borderBottom: '2px solid #e5e7eb',
      position: 'relative',
    },
    tabUnderline: {
      padding: '16px',
      background: 'none',
      border: 'none',
      fontSize: '15px',
      fontWeight: 600,
      color: '#6b7280',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      position: 'relative',
      '&:hover': {
        color: '#374151',
      },
    },
    underlineIndicator: {
      position: 'absolute',
      bottom: '-2px',
      height: '3px',
      background: 'linear-gradient(90deg, #3b82f6, #8b5cf6)',
      borderRadius: '2px 2px 0 0',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    },
    btnSpec: {
      display: 'flex',
      gap: 10,
      justifyContent: 'end',
      marginTop: '15px',
    },
    orgName: {
      fontSize: 22,
      fontWeight: 600,
    },
  })
const useProductUsageHistoryStyles = makeStyles(ProductUsageHistoryStyle)
export default useProductUsageHistoryStyles
